module.exports = __webpack_public_path__ + "static/media/SoukouMincho.7ac37dc9.svg";